import { Col, Container, Row, Form } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { editStation } from "../../slices/stations/editstation/thunk";
import { ToastContainer } from "react-toastify";
import { InitialValues } from "./constants/stationsIntialValues";
import FormLine1 from "./FormLine1";
import FormLine2 from "./FormLine2";
import FormLine3 from "./FormLine3";
import FormLine4 from "./FormLine4";
import FormLine5 from "./FormLine5";
import { validationstation } from "./constants/Validationscheme";
import { Loader } from "../Utils/Loader";
import CommonButton from "../Utils/CommonButton";
import { PAGE_TITLES } from "../Common/constants";
import { fetchCountries } from "../../slices/customer/countries/thunk";
import { countryOptionss } from "../OperatorManagement/Constant/Options";
import {
  commonIDFunction,
  optionsForCustomerDetails,
} from "../Customers/constants/constantFunctions";
import { fetchCities } from "../../slices/customer/cities/thunk";
import { fetchStates } from "../../slices/customer/states/thunk";
import { createStation } from "../../slices/stations/createStation/thunk";
import ViewStation from "./ViewStation";
import moment from "moment";
import { getAllAttribute } from "../../slices/services/addservice/provisionalattribute/thunk"; // adjust path
import { NonSearchableAttributes } from "../Customers/NonSearchableAttributes"; // adjust path
import ConnectorList from "./ConnectorList";

// both operational-hours attributes (From / To)
const TIME_ATTRS = ["Opening Time", "Closing Time"];

export default function EditStation() {
  const location = useLocation();
  const state = location.state;
  const isCreate = location.pathname.includes("create-station");
  const isView = location.pathname.includes("view-station");
  const isEdit = location.pathname.includes("station/");
  const navigate = useNavigate();
  const [loading, setLoading] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [callState, setCallState] = useState(false);
  const [callCity, setCallCity] = useState(false);
  const dispatch = useDispatch();

  // Attribute states
  const [usageAttributes, setUsageAttributes] = useState([]);
  const [nonSearchableValues, setNonSearchableValues] = useState([]);
  const [nonSearchableFormErrorsValues, setNonSearchableFormErrorsValues] =
    useState({});

  let defaultInitialValues = InitialValues;
  let optionCity = [];
  let optionState = [];
  const [cities, setCities] = useState([]);
  let initialValues = {
  ...defaultInitialValues,
  connectors: defaultInitialValues.connectors?.length
    ? defaultInitialValues.connectors
    : [
        {
          connectorId: "",
          connectorType: "",
          powerKw: "",
          connectorStatus: "",
          timestamp: "",
        },
      ],
};

  const [dynamicGroups, setDynamicGroups] = useState({});
const [existingAttributes, setExistingAttributes] = useState([]);

  // Fetch countries
  useEffect(() => {
    dispatch(fetchCountries(setLoading, setCallState));
  }, [dispatch]);

  // Fetch all attributes
  useEffect(() => {
    dispatch(getAllAttribute(setLoading));
  }, [dispatch]);

  // Get attributes from Redux store — adjust "state.Provision.provision" to match your reducer
  const allAttributes = useSelector((state) => state.Provisional.provisional);

  // Filter usage attributes and initialize nonSearchableValues whenever allAttributes changes
  // useEffect(() => {
  //   if (allAttributes && allAttributes.length > 0) {
  //     const filtered = allAttributes.filter((attr) => attr.type === "usage");
  //     setUsageAttributes(filtered);

  //     setNonSearchableValues(
  //       filtered.map((attr) => {
  //         const existing = existingAttributes.find(
  //           (a) => a.attributeName === attr.name,
  //         );

  //         return {
  //           name: attr.name,
  //           value: existing
  //             ? existing.attributeValue
  //             : attr.default !== "0"
  //               ? attr.default
  //               : "",
  //           touched: false,

  //           listValues: [
  //             {
  //               value: existing ? existing.attributeValue : "",
  //               priority: "",
  //               touched: false,
  //             },
  //           ],
  //         };
  //       }),
  //     );
  //   }
  // }, [allAttributes]);

// useEffect(() => {
//   if (!allAttributes?.length) return;

//   const filtered = allAttributes.filter((attr) => attr.type === "usage");
//   setUsageAttributes(filtered);

//   const stationExistingAttrs = state?.stationDetails?.attributes || [];
//   setExistingAttributes(stationExistingAttrs);

//   setNonSearchableValues(
//     filtered.map((attr) => {
//       const existing = stationExistingAttrs.find(
//         (a) => a.attributeName === attr.name,
//       );
//       return {
//         name: attr.name,
//         value: existing
//           ? existing.attributeValue
//           : attr.default !== "0"
//             ? attr.default
//             : "",
//         touched: false,
//         listValues: [
//           {
//             value: existing ? existing.attributeValue : "",
//             priority: "",
//             touched: false,
//           },
//         ],
//       };
//     }),
//   );
// }, [allAttributes]);

useEffect(() => {
  if (!allAttributes?.length) return;

  const filtered = allAttributes.filter((attr) => attr.type === "usage");
  setUsageAttributes(filtered);

  const stationExistingAttrs = state?.stationDetails?.attributes || [];
  setExistingAttributes(stationExistingAttrs);

  const values = filtered.map((attr) => {
    const existing = stationExistingAttrs.find(
      (a) => a.attributeName === attr.name,
    );

    return {
      name: attr.name,
      value: existing
        ? existing.attributeValue
        : attr.default !== "0"
          ? attr.default
          : "",
      touched: false,
      listValues: [
        {
          value: existing ? existing.attributeValue : "",
          priority: "",
          touched: false,
        },
      ],
    };
  });

  // Make sure BOTH From / To entries exist, with the saved value on edit
  TIME_ATTRS.forEach((timeName) => {
    if (values.some((v) => v.name === timeName)) return;

    const existing = stationExistingAttrs.find(
      (a) => a.attributeName === timeName,
    );

    values.push({
      name: timeName,
      value: existing ? existing.attributeValue : "",
      touched: false,
      listValues: [
        {
          value: existing ? existing.attributeValue : "",
          priority: "",
          touched: false,
        },
      ],
    });
  });

  setNonSearchableValues(values);
}, [allAttributes]);

useEffect(() => {
  if (!usageAttributes?.length) return;

  const listAttrs = usageAttributes.filter((attr) => attr.valueType === "list");
  if (!listAttrs.length) return;

  const stationExistingAttrs = state?.stationDetails?.attributes || [];

  const initialState = {};

  listAttrs.forEach((attr) => {
    const existing = stationExistingAttrs.find(
      (a) => a.attributeName === attr.name,
    );

    if (existing && Array.isArray(existing.attributeValue)) {
      initialState[attr.name] = existing.attributeValue.map((val) => ({
        value: val,
        touched: false,
      }));
    } else {
      // Adds one empty row so Generate button always renders
      initialState[attr.name] = [{ value: "", touched: false }];
    }
  });

  setDynamicGroups(initialState);
}, [usageAttributes]);

  const countries = useSelector((state) => state.Countries.countries);
  const countryOptions = countryOptionss(countries?.countries);

  if (state && state.stationDetails) {
    const stationDetails = state.stationDetails;
    const {
      address,
      adminStatus,
      availabilityStartTime,
      availabilityEndTime,
      ...restDetails
    } = stationDetails;
    const [address_line1 = "", address_line2 = ""] = address
      ? address?.split(",")
      : ["", ""];
    initialValues = {
      ...defaultInitialValues,
      ...restDetails,
      address,
      address_line1: address_line1.trim(),
      address_line2: address_line2.trim(),
      country: restDetails?.country ? { "value": restDetails?.country, "label": restDetails?.country } : "",
      state: restDetails?.state ? { "value": restDetails?.state, "label": restDetails?.state } : "",
      city: restDetails?.city ? { "value": restDetails?.city, "label": restDetails?.city } : "",
      modem: {
        ...defaultInitialValues.modem,
        ...restDetails.modem,
      },
      coordinates: {
        ...defaultInitialValues.coordinates,
        ...restDetails.coordinates,
      },
      hosts: stationDetails.partnerIDs || [],
    connectors: (stationDetails.connectors || []).map((connector) => ({
  ...connector,
  connectorId: connector.connectorId ?? "",
  connectorType:
    connector.connectorType ?? connector.connectorName ?? "",
  powerKw: connector.powerKw ?? "",
  isExistingConnector: Boolean(connector.connectorId),
})),
      adminStatus: adminStatus,
    };
  }

  useEffect(() => {
    if (callState) {
      dispatch(fetchStates(selectedCountry, setCallCity));
    }
  }, [dispatch, isEdit, selectedCountry]);

  let statesData = useSelector((state) => state.States.states);
  let stateID = commonIDFunction(statesData?.states);
  optionState = optionsForCustomerDetails(stateID);

  useEffect(() => {
    if (callCity) {
      dispatch(fetchCities(selectedCountry, selectedState));
    }
  }, [dispatch, isEdit, selectedCountry, selectedState]);

  let cityData = useSelector((state) => state.Cities.cities);
  let cityID = commonIDFunction(cityData?.cities);
  optionCity = optionsForCustomerDetails(cityID);

  // Validate mandatory usage attributes before submit
  const validateAttributes = () => {
    let isValid = true;
    const updatedErrors = {};

    nonSearchableValues.forEach((attr) => {
      usageAttributes.forEach((attr) => {
        if (attr.valueType === "list") {
          const rows = dynamicGroups?.[attr.name] || [];

          const hasEmpty = rows.some(
            (row) => !row.value || row.value.trim() === "",
          );

          if (attr.mandatory && hasEmpty) {
            updatedErrors[attr.name] = `${attr.name} is required`;
            isValid = false;
          }
        }
      });
    });

    setNonSearchableFormErrorsValues(updatedErrors);

    // Mark all as touched so errors show
    if (!isValid) {
      setNonSearchableValues((prev) =>
        prev.map((attr) => ({ ...attr, touched: true })),
      );
    }

    return isValid;
  };

  const onSubmit = (values) => {
    const attributesPayload = usageAttributes
      .map((attr) => {
        if (attr.valueType === "list") {
          const listValues = (dynamicGroups?.[attr.name] || [])
            .map((row) => row.value)
            .filter((val) => val && val.trim() !== "");

          if (!listValues.length) return null;

          return {
            attributeName: attr.name,
            attributeValue: listValues,
          };
        }

        const normalAttr = nonSearchableValues.find(
          (a) => a.name === attr.name,
        );

        if (!normalAttr?.value) return null;

        return {
          attributeName: attr.name,
          attributeValue: normalAttr.value,
        };
      })
      .filter(Boolean);

      // Always send BOTH time attributes (From + To) in the same "HH:mm" format
TIME_ATTRS.forEach((timeName) => {
  const alreadyAdded = attributesPayload.some(
    (a) => a.attributeName === timeName,
  );

  if (alreadyAdded) return;

  const timeEntry = nonSearchableValues.find(
    (a) => a.name === timeName,
  );

  if (timeEntry?.value) {
    attributesPayload.push({
      attributeName: timeName,
      attributeValue: timeEntry.value,
    });
  }
});

    const jsonObj = JSON.stringify({
      stationID: values.stationID,
      name: values.name,
      serialNumber: values.serialNumber,
      model: values.model,
      address: values.address_line1.trim() + "," + values.address_line2.trim(),
      country: values?.country?.value,
      state: values?.state?.value,
      city: values?.city?.value,
      zipCode: +values?.zipCode,
      vendorName: values.vendorName,
      firmwareVersion: values.firmwareVersion,
      modem: {
        iccid: values.modem.iccid,
        imsi: values.modem.imsi,
      },
      timeZone: values.timeZone,
      coordinates: {
        latitude: parseFloat(values?.coordinates?.latitude),
        longitude: parseFloat(values?.coordinates?.longitude),
      },
      adminStatus: isCreate ? "Active" : values.adminStatus,
      OCPPVersion: values.OCPPVersion ? values.OCPPVersion : "ocpp1.6",
      partnerIDs: values.hosts || [],
      attributes: attributesPayload,
      // connectors: values?.connectors?.map((connector) => ({
      //   connectorId: connector?.connectorId,
      //   connectorName: connector?.connectorName,
      //   connectorStatus: connector?.connectorStatus,
      //   timestamp: connector?.timestamp,
      // })),
      connectors: (values.connectors || []).map((connector) => ({
  connectorId:
    connector.connectorId !== "" && connector.connectorId != null
      ? parseInt(connector.connectorId, 10)
      : "",
  connectorType: connector.connectorType ?? "",
  powerKw:
    connector.powerKw !== "" && connector.powerKw != null
      ? parseFloat(connector.powerKw)
      : null,
  connectorStatus: connector.connectorStatus ?? "",
  // timestamp: connector.timestamp ?? "",
})),
    });

    isCreate ? CreateStation(jsonObj) : EditStationFn(jsonObj);
  };

  const EditStationFn = async (jsonObj) => {
    dispatch(editStation(jsonObj, state, setLoading, navigate));
  };

  const CreateStation = async (jsonObj) => {
    dispatch(createStation(jsonObj, setLoading, navigate));
  };

  return (
    <div>
      <Formik
        validationSchema={validationstation(state)}
        initialValues={initialValues}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          errors,
          touched,
          values,
          resetForm,
          setFieldTouched,
          setFieldValue,
        }) => {
          return (
            <Form
              id="csms"
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
                const attrValid = validateAttributes();
                if (
                  values.stationid !== "" &&
                  values.name !== "" &&
                  values.serialNumber !== "" &&
                  values.address_line1 !== "" &&
                  values.address_line2 !== "" &&
                  values.country !== "" &&
                  values.state !== "" &&
                  values.city !== "" &&
                  values.zipCode !== "" &&
                  values.vendorName !== "" &&
                  values.model !== "" &&
                  attrValid
                ) {
                  onSubmit(values);
                }
              }}
            >
              <div>
                <div className="page-content">
                  <Container fluid>
                    <BreadCrumb
                      title={
                        isCreate
                          ? "Add Station"
                          : isView
                            ? "View Station"
                            : PAGE_TITLES.EDIT_STATION
                      }
                      pageTitle={PAGE_TITLES.STATION_LIST}
                    />
                    <ToastContainer position="top-center" />
                    <Row>
                      <div className="mb-2">
                        <h5 className="rv-page-title p-1">
                          {isCreate
                            ? "Add Station"
                            : isView
                              ? "View Station"
                              : "Edit Station"}
                        </h5>
                      </div>

                      {isView ? (
                        <ViewStation values={values} />
                      ) : (
                        <Col lg={12}>
                          <div className="border p-4">
                            <div className="live-preview">
                              <Row className="gy-4">
                                <FormLine1
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  setFieldTouched={setFieldTouched}
                                  setFieldValue={setFieldValue}
                                />
                                <FormLine2
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  setFieldTouched={setFieldTouched}
                                  setFieldValue={setFieldValue}
                                  options={countryOptions}
                                  optionState={optionState}
                                  optionCity={optionCity}
                                  setSelectedCountry={setSelectedCountry}
                                  setSelectedState={setSelectedState}
                                  setSelectedCity={setSelectedCity}
                                  setCities={setCities}
                                />

                                <FormLine3
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  setFieldTouched={setFieldTouched}
                                  setFieldValue={setFieldValue}
                                  isCreate={isCreate}
                                />
                                <FormLine4
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  setFieldTouched={setFieldTouched}
                                  setFieldValue={setFieldValue}
                                  isCreate={isCreate}
                                />

                                <FormLine5
                                  values={values}
                                  touched={touched}
                                  errors={errors}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  setFieldValue={setFieldValue}
                                />
                                {/* Usage Attributes Section */}
                              </Row>
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>

                  {!isView && !isCreate && (
                    <Row>
                      <Col lg={12}>
                        <ConnectorList
                          values={values}
                          setFieldValue={setFieldValue}
                          isEdit={!isCreate}
                          isView={isView}
                        />
                      </Col>
                    </Row>
                  )}

                    {!isView && (
                      <Row>
                        <div className="live-preview">
                          <div className="border rounded-1 p-3 mt-3 ">
                            {usageAttributes.length > 0 && (
                              <Col lg={12}>
                                <NonSearchableAttributes
                                  Attributes={usageAttributes}
                                  nonSearchableValues={nonSearchableValues}
                                  setNonSearchableValues={
                                    setNonSearchableValues
                                  }
                                  nonSearchableFormErrorsValues={
                                    nonSearchableFormErrorsValues
                                  }
                                  dynamicGroups={dynamicGroups}
                                  setDynamicGroups={setDynamicGroups}
                                  existingAttributes={existingAttributes}
                                  isEdit={!isCreate}
                                  showGenerateButton={true}
                                />
                              </Col>
                            )}
                          </div>
                        </div>
                      </Row>
                    )}
                    {!isView && (
                      <div className="d-flex justify-content-between gap-2 flex-wrap pe-1 pb-3 my-5">
                        <div className="d-flex gap-2 ms-auto">
                          <CommonButton
                            outline={true}
                            className={
                              "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                            }
                            color={"main-color"}
                            type={"reset"}
                            buttonAction={() => {
                              navigate("/station");
                            }}
                            buttonText={"Cancel"}
                            icon={
                              <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                            }
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                          />
                          <CommonButton
                            color={"main-color"}
                            className={
                              "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                            }
                            icon={
                              <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-2"></i>
                            }
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                            type={"submit"}
                            buttonText={"Submit"}
                          />
                        </div>
                      </div>
                    )}
                  </Container>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      {loading && <Loader />}
    </div>
  );
}
